const ITEMS = [
  "Noleggio Sicuro × DoYou Italy",
  "Assistenza telefonica +39 377 389 9146",
  "Auto urbane • Berline • SUV • Furgoni",
  "Zero costi nascosti",
  "Consegna rapida in tutta Italia",
];

export const Marquee = () => (
  <div className="bg-slate-900 py-5 overflow-hidden marquee-mask" data-testid="editorial-marquee">
    <div className="animate-marquee flex whitespace-nowrap w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-display text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-slate-100 px-8">
                {item}
              </span>
              <span className="w-2 h-2 rounded-full bg-emerald-500" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
